module.exports = __webpack_public_path__ + "static/happy-couple-hiking-near-a-lake-tablet.6b37a310.webp";